import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmZuh0cpEXJLSVpLZxJN7-GmtBMGoIPt8",
  authDomain: "cerify-d6812.firebaseapp.com",
  projectId: "cerify-d6812",
  storageBucket: "cerify-d6812.appspot.com",
  messagingSenderId: "991992626348",
  appId: "1:991992626348:web:ec7486e632b1a646f7f309",
  measurementId: "G-R3PLSN6ZYG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };